module.exports = __webpack_public_path__ + "assets/completed.f69b58d0.svg";